import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'

@Component({
  selector: 'dmmp-event-search-result',
  templateUrl: './event-search-result.component.html',
})
export class EventSearchResultComponent implements OnInit {

  @Input() module
  @Input() identifier
  @Input() defaultClass

  @Input() totalEventsTitle = 'eventos encontrados'
  @Input() moduleTitle = 'Resultados de la búsqueda'

  @Input() searchResult
  @Input() currentFilters
  @Input() paginationState
  @Input() eventsResult

  @Output() anchorCustom = new EventEmitter()
  @Output() page = new EventEmitter()
  @Output() deleteFilterEmitter = new EventEmitter()
  @Output() clearFiltersEmitter = new EventEmitter()

  @Input() loaderState = false
  @Input() clearAllLabel = 'Borrar todo'
  @Output() redirectPage: EventEmitter<any> = new EventEmitter<any>()

  constructor() {
  }

  ngOnInit(): void {
  }

  deleteFilter(filterEle) {
    this.currentFilters.options.splice(this.currentFilters?.options?.indexOf(filterEle), 1)
    this.deleteFilterEmitter.emit(this.currentFilters)
  }

  clearFilters() {
    this.clearFiltersEmitter.emit()
  }
}
